import React from "react";
import { useSelector } from "react-redux";
import { makeStyles, Grid, Typography, Box } from "@material-ui/core";
import { useState, useEffect } from "react";
import { commonService } from "../../../services/common.service";
import { grey100 } from "material-ui/styles/colors";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";

const useStyle = makeStyles((theme) => ({
  image: {
    margin: "1rem",
  },
  box: {
    justify: "center",
    backgroundColor: grey100,
    border: "1px dashed" + theme?.palette?.eRich?.base,
    margin: "1rem",
  },
  success: {
    color: theme?.palette?.eSecondary?.base,
    fontWeight: "bold",
  },
  successContent: {
    color: theme?.palette?.ePrimary?.base,
    fontWeight: "bold",
    margin: "1rem",
  },
  yourReqLabel: {
    fontWeight: "bold",
  },
  completeLabel: {
    color: theme?.palette?.eSecondary?.base,
    fontWeight: "bold",
  },
  content: {
    margin: "2rem",
  },
  margin: {
    [theme.breakpoints.up("md")]: {
      marginTop: "4%",
    },
  },
}));

export default function ECompleted() {
  const trackClass = useStyle();
  const { t: trackConnectionLabel, ready: labelReady } = useTranslation(
    "label-E_TRACKING_NEW_CONNECTION"
  );
  const { t: content, ready: contentReady } = useTranslation(
    "content-E_TRACK_CONNECTION_REQUEST"
  );
  const [meterSuccessImagePath, setMeterSuccessImagePath] = useState("");
  let meterSuccessImage = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup
        ?.E_TRACK_METER_INSTALLATION_IMAGE
  );
  useEffect(() => {
    if (meterSuccessImage) {
      commonService.getAssestUrl(meterSuccessImage).then((response) => {
        setMeterSuccessImagePath(response);
      });
    }
  }, [meterSuccessImage]);

  return (
    <>
      <Grid container justify="center" className={trackClass.margin}>
        <Grid item>
          {meterSuccessImagePath && (
            <img
              className={trackClass.image}
              src={meterSuccessImagePath?.assetPath}
              alt={
                labelReady
                  ? trackConnectionLabel("E_TRACK_SUCCESS_FALLBACK_IMAGE")
                  : ""
              }
            />
          )}
        </Grid>

        <Grid container justify="center">
          <Grid item>
            {labelReady
              ? trackConnectionLabel("E_CONGRATULATIONS")
              : ""}
          </Grid>
        </Grid>
        <Grid container justify="center">
          <Grid item>
            <Box className={trackClass.box}>
              {labelReady ? (
                <Typography variant="body2" className={trackClass.content}>
                  <span className={trackClass.yourReqLabel}>
                    {trackConnectionLabel("E_COMPLETED")}
                  </span>{" "}
                  <span className={trackClass.completeLabel}>
                    {trackConnectionLabel("E_TRACK_COMPLETED")}
                  </span>{" "}
                  <span className={trackClass.yourReqLabel}>
                    {trackConnectionLabel("E_VALIDATED")}
                  </span>
                </Typography>
              ) : (
                <Skeleton />
              )}
            </Box>
          </Grid>
        </Grid>
        <Grid container justify="center">
          <Grid item className={trackClass.successContent}>
            {contentReady ? (
              <Typography
                variant="subtitle2"
                dangerouslySetInnerHTML={{
                  __html: content("E_TRACK_SUCCESS_CONTENT").answer,
                }}
              ></Typography>
            ) : (
              <Skeleton />
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
